module.exports = __webpack_public_path__ + "static/media/q-and-a.b4058232.png";